export default __webpack_public_path__ + "static/media/spinner.0c238a17.gif";